import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ActionModel({ setShowActionModel }) {
    return (
        <div
            className="modal show"
            style={{
                display: 'block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)', // Center the modal
                backgroundColor: 'rgba(0, 0, 0, 0.1)', // Semi-transparent background
                width: '100%',
                height: '100%',
                zIndex: '1050', // Ensure it appears on top
            }}
        >
            <Modal.Dialog>
                <Modal.Header>
                    <Modal.Title>Modal title</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Modal body text goes here.</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowActionModel(false)}>Close</Button>
                    <Button variant="primary">Save changes</Button>
                </Modal.Footer>
            </Modal.Dialog>
        </div>
    );
}

export default ActionModel;